import { createFileRoute } from '@tanstack/react-router'

import { z } from 'zod'

import { CanvasContainer } from '@/pages/Workflows/WorkflowCanvas/CanvasContainer'

export const Route = createFileRoute(
  '/_app/library/workflows/$workflowId/canvas',
)({
  validateSearch: z.object({
    debug: z
      .union([z.string(), z.boolean()])
      .optional()
      .transform((val) => {
        if (val === true || val === 'true') return 'true'
        if (val === false || val === 'false') return 'false'
        return undefined
      }),
    automationId: z.string().optional(),
    planId: z.string().optional(),
  }),
  component: CanvasContainer,
})
